import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SERVICE_LINES, AUDIENCE_STREAMS, REGIONS } from "@/lib/constants";

const Field = ({ id, label, value, onChange, options, placeholder, hint }) => (
  <div className="space-y-2">
    <Label htmlFor={id}>{label}</Label>
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger id={id} className="h-10 rounded-xl bg-card" data-testid={`${id}-select`}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="rounded-xl">
        {options.map((o) => {
          const v = typeof o === "string" ? o : o.value;
          const l = typeof o === "string" ? o : o.label;
          return (
            <SelectItem key={v} value={v} data-testid={`${id}-option-${v.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              {l}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
    {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const DefaultsFields = ({ values, onChange }) => (
  <div className="grid gap-5 md:grid-cols-3">
    <Field id="service-line" label="Service line" value={values.service_line} onChange={(v) => onChange("service_line", v)} options={SERVICE_LINES} placeholder="Choose a service line" hint="Equity sits inside M&A." />
    <Field id="audience-stream" label="Audience stream" value={values.audience_stream} onChange={(v) => onChange("audience_stream", v)} options={AUDIENCE_STREAMS} placeholder="Choose an audience" />
    <Field id="region" label="Region" value={values.region} onChange={(v) => onChange("region", v)} options={REGIONS} placeholder="Choose a region" />
  </div>
);
